/**
 * Route wrapper for the creation flow.
 *
 * Creation and editing share this route shape and the same form: an edit is the same content with
 * its destination already decided. Being a route rather than a mode of the list is what lets the
 * header name it and the browser's back button behave.
 *
 * @module Pages/BUs/WhatsNew
 */

import { useQuery } from '@tanstack/react-query';
import type { JSX } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { UTLoading } from '@group-link-one/gl-ui/utilities';
import { WhatsNewCreate } from './Components/WhatsNewCreate/WhatsNewCreate';
import { getWhatsNewById } from './Services/WhatsNew.service';

export const WhatsNewCreatePage = (): JSX.Element => {
  const navigate = useNavigate();
  const { whatsNewId } = useParams<{ whatsNewId: string }>();

  const backToList = () => {
    navigate('/business-units/whats-new');
  };

  const { data: editing, isLoading } = useQuery({
    queryKey: ['whats-new', 'detail', whatsNewId],
    queryFn: () => getWhatsNewById(whatsNewId ?? ''),
    enabled: Boolean(whatsNewId),
  });

  // The form seeds from the announcement, so it must not mount before it arrives.
  if (whatsNewId && isLoading) return <UTLoading type='dots' />;

  return <WhatsNewCreate onBack={backToList} onSuccess={backToList} editing={editing} />;
};
